import { h, Component } from 'preact';
import UpWorld from 'components/bolt/upWorld/upWorld.js';
import Airport from 'components/bolt/airport/airport.js';
import DownWorld from 'components/bolt/downWorld/downWorld.js';
import Bricks from 'components/bolt/downWorld/bricks/bricks.js';
import Rob from 'components/bolt/rob/rob.js';
import Intro from 'components/bolt/main/intro/intro.js';
import IntroPopUp from 'components/bolt/main/introPopUp/introPopUp.js';
import Cursor from 'components/bolt/main/cursor/cursor.js';
import Controls from 'components/bolt/controls/controls.js';
import Store from 'store/store';
import Sound from 'components/bolt/sound/sound.js';
import copy from 'helpers/copy.js';
import { loadImage } from 'helpers/index.js';
import { smoothScrollTo } from 'utils/smoothScroll';
import s from 'components/bolt/main/main.sss';
import { getDateNum } from 'utils/querySimulation';
import { joinClasses } from 'utils/utils';
import Legals from './legals/legals';
export default class Main extends Component {

	constructor(props) {
		super(props);
		this.props = props;

		this.state = {
			introOpen: true,
			introPopUpOpen: false,
			introSeen: false,
			currentPage: 'homepage',
			muted: false,
			motionPaused: false,
			legalsOpen: false,
			downWorldFound: false,
			updateUpWorld: false,
			showScrollArea: true
		};

		this.$bricks;

		this.hideIntroPopUp = this.hideIntroPopUp.bind(this);
		this.toggleMute = this.toggleMute.bind(this);
		this.toggleMotion = this.toggleMotion.bind(this);
		this.toggleLegals = this.toggleLegals.bind(this);
		this.hideIntro = this.hideIntro.bind(this);
		this.resetScroll = this.resetScroll.bind(this);
		this.toggleDownWorld = this.toggleDownWorld.bind(this);
		this.sendPageLoadEvent = this.sendPageLoadEvent.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.isMobile = this.isMobile.bind(this);
		this.isDesktop = true;

		this.addScrollAreaTimer = null;
	}


	componentDidMount() {		
		const airportContainer = document.getElementById('airport-container');
		if (airportContainer) {
			smoothScrollTo(document.getElementById('mainScroll'), airportContainer, 0);
		}	
		const introSeen = localStorage.getItem('IntroSeen');
		this.setState({ introSeen: introSeen ? true : false });
		document.getElementById('mainScroll').addEventListener('scroll', this.onScroll);
		this.isDesktop = !this.isMobile();
		Store.on('RESET_SCROLL', (behavior) => this.resetScroll(behavior));
		this.preloadBg();
	}

	componentWillUnmount() {
		document.getElementById('mainScroll').removeEventListener('scroll', this.onScroll);
	}

	onScroll() {
		const { currentPage, downWorldFound, updateUpWorld } = this.state;
		const airportContainer = document.getElementById('airport-container');
		const upWorldContainer = document.getElementById('upWorld-container');
		const scrollAreaContainer = document.getElementById('scrollArea-container');
		
		if (downWorldFound) {
			if (scrollAreaContainer.getBoundingClientRect().top + 10 > 0) {//SCROLL AREA
				if (currentPage != 'scrollArea' ) {
					this.$bricks.playVideo();		
				}
			} else { //DOWNWORLD
				if (currentPage != 'downWorld' ) {
					Store.emit('CLOSE_CENTRAL_EASTER_EGG', event);
					this.sendPageLoadEvent('down-world');
					this.setState({ currentPage: 'downWorld' });
				}
			}

			if (updateUpWorld) {
				this.setState({ updateUpWorld: false });
			}

		} else { //UPWOLRD
			if ( airportContainer.getBoundingClientRect().top - (upWorldContainer.getBoundingClientRect().height / 2) > 0 ) {	//UPWORLD	
				if (currentPage != 'upWorld') {
					this.sendPageLoadEvent('up-world');
					this.setState({ currentPage: 'upWorld', showScrollArea: false });
					window.clearTimeout(this.addScrollAreaTimer);
					this.addScrollAreaTimer = null;
					Store.emit('CLOSE_CENTRAL_EASTER_EGG', event);
					Store.emit('ROB_UPDATE', 'upWorld');
					Store.emit('PLAY_MUSIC', 'upWorld' + getDateNum());
					this.$bricks.reset();
					
				}
			} else { //HOMEPAGE
				if (currentPage != 'homepage') {
					this.setState({ currentPage: 'homepage' });
					if (currentPage != 'scrollArea') {
						Store.emit('CLOSE_UPWORLD_EASTER_EGG', event);
						Store.emit('CLOSE_DOWNWORLD_EASTER_EGG', event);
						this.sendPageLoadEvent('central-navigation');
						Store.emit('ROB_UPDATE', 'homepage');
						Store.emit('PLAY_MUSIC', 'airport');
					}
				}
			}

			if (this.state.showScrollArea) {
				
				if (scrollAreaContainer.getBoundingClientRect().bottom - 10 <= window.innerHeight) {	//SCROLL AREA
					if (currentPage != 'scrollArea') {
						this.$bricks.playVideo();		
						this.setState({ currentPage: 'scrollArea' });
					}
				} 
			} 

			if ( airportContainer.getBoundingClientRect().top <= 0) {

				if (!this.addScrollAreaTimer) {
					this.addScrollAreaTimer = setTimeout(() => {

						this.setState({ showScrollArea: true });
						window.clearTimeout(this.addScrollAreaTimer);
						this.addScrollAreaTimer = null;
					}, 1000);
				}
			}

			if (airportContainer.getBoundingClientRect().top > 0 ) {
				if (!updateUpWorld) {
					this.setState({ updateUpWorld: true });
				}
			
			} else {
				if (updateUpWorld) {
					this.setState({ updateUpWorld: false });
				}
			}
		}
	}

	async preloadBg() {
		const bgSrc = `${this.props.appData?.urls?.roots?.image || ''}/o5yrlk.webp`;
		await loadImage(bgSrc);
		this.$skyContainer.style.backgroundImage = `url(${bgSrc})`;
		Store.emit('KEY_ASSET_LOADED', 'mainBg');
	}

	sendPageLoadEvent(page) {
		Store.emit('CUSTOM_EVENT', {
			category: page,
			action: 'page-view'
		});
	}

	toggleMute() {
		this.setState({
			muted: !this.state.muted
		});
	}

	toggleMotion() {
		this.setState({
			motionPaused: !this.state.motionPaused
		});
	}

	toggleLegals() {
		this.setState({
			legalsOpen: !this.state.legalsOpen
		});
	}

	resetScroll(behavior) {
		setTimeout(() => {
			document.getElementById('mainScroll').scrollTo({
				top: window.innerHeight,
				behavior: behavior || 'smooth'
			});
		}, 1000);
	}

	toggleDownWorld() {
		const { downWorldFound } = this.state;
		if (downWorldFound) {
			setTimeout(() => {
				this.setState({ downWorldFound: false });
				this.resetScroll('instant');
			}, 2800);
		} else {
			Store.emit('ROB_UPDATE', 'downWorld');
			Store.emit('PLAY_MUSIC', 'downWorld');
			setTimeout(() => {
				this.setState({ downWorldFound: true });
				setTimeout(() => {
					document.getElementById('mainScroll').scrollTo({
						top: document.getElementById('mainScroll').scrollHeight,
						behavior:  'smooth'
					});
				}, 1000);
			}, 2800);
		}	
	}

	hideIntro() {
		const { introSeen } = this.state;
		this.setState({ introOpen: false });
		
		if (introSeen) {
			this.sendPageLoadEvent('central-navigation');
			Store.emit('ROB_UPDATE', 'homepage');
			Store.emit('PLAY_MUSIC', 'airport');
		} else {
			this.setState({ introPopUpOpen: true });
		}
		
	}

	hideIntroPopUp() {
		const { introSeen } = this.state;
		this.setState({ introPopUpOpen: false });
		if (!introSeen) {
			this.sendPageLoadEvent('central-navigation');
			Store.emit('ROB_UPDATE', 'homepage');
			Store.emit('PLAY_MUSIC', 'airport');
		}
		localStorage.setItem('IntroSeen', true);
	}

	isMobile() {
		const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.platform == 'MacIntel' && navigator.maxTouchPoints > 1);
		return isMobile;
	}

	render(props) {
		const mediaRoot = props.appData?.urls?.roots?.media || '';
		const videoRoot = props.appData?.urls?.roots?.video || '';
		const imageRoot = props.appData?.urls?.roots?.image || '';
		const imageRegionRoot = props.appData?.urls?.roots?.imageRegion || '';
		const region = props.appData?.meta?.region?.slug || 'us';
		const videoRegionRoot = `${videoRoot}/regions/${region}`;
		const { introOpen, introPopUpOpen, muted, motionPaused, legalsOpen, currentPage, downWorldFound, updateUpWorld, showScrollArea } = this.state;
		return (
			<div class={s.container}>
				<div
					class={joinClasses(s.skyContainer, showScrollArea && s.showScrollArea)}
					ref={ref => this.$skyContainer = ref}
				>
					<UpWorld 
						copy={copy}
						imageRoot={imageRoot}
						videoRoot={videoRoot}
						downWorldFound={downWorldFound}
						updateUpWorld={updateUpWorld}
					/>
					<Airport
						copy={copy}
						videoRoot={videoRoot}
						videoRegionRoot={videoRegionRoot}
						imageRoot={imageRoot}
						imageRegionRoot={imageRegionRoot}
						client={props.client}
						introOpen={introOpen}
						muted={muted}
						motionPaused={motionPaused}
						legalsOpen={legalsOpen}
						toggleMute={this.toggleMute}
						toggleMotion={this.toggleMotion}
						toggleLegals={this.toggleLegals}
						currentPage={currentPage}
						downWorldFound={downWorldFound}
					/>
					
					<DownWorld 
						imageRoot={imageRoot}
						downWorldFound={downWorldFound}
						showScrollArea={showScrollArea}
						videoRoot={videoRoot}
						client={props.client}
						copy={copy}
					/>
				</div>

				<Bricks
					ref={ref => this.$bricks = ref} 
					videoRoot={videoRoot}
					toggleDownWorld={this.toggleDownWorld}
					resetScroll={(behavior) => this.resetScroll(behavior)}
					muted={muted}
				/> 
				
				<Rob
					copy={copy}
					imageRoot={imageRoot}
					client={props.client}
				/>	
				<IntroPopUp
					imageRoot={imageRoot} 
					videoRegionRoot={videoRegionRoot}
					isOpen={introPopUpOpen} 
					onClose={this.hideIntroPopUp} 
				/>
			
				<Intro
					imageRoot={imageRoot} 
					videoRoot={videoRoot} 
					isOpen={introOpen} 
					onClose={this.hideIntro} 
					copy={copy}
				/> 
			
				<Sound audioRoot={`${mediaRoot}/audio`} muted={muted} />
				{props.client?.isDesktopWidth && (
					<Controls
						toggleMute={this.toggleMute}
						toggleMotion={this.toggleMotion}
						toggleLegals={this.toggleLegals}
						muted={muted}
						motionPaused={motionPaused}
						legalsOpen={legalsOpen}
						imageRoot={imageRoot}
						currentPage={currentPage}
						copy={copy}
						legalsPromptCopy={copy.$legalsPrompt}
					/>
				)}
				
				<Legals
					copy={copy}
					legalsOpen={legalsOpen}
					imageRoot={imageRoot}
					currentPage={currentPage}
					toggleLegals={this.toggleLegals}
				/>

				{this.isDesktop && <Cursor imageRoot={imageRoot} />}
			</div>
		);
	}
}
